<template>
  <div style="margin: 20px">
    <div class="flex items-center" style="align-items: flex-end;">

      <div class="btn-add-entry" :style="{ backgroundColor: enableCreateIndividualApp ? '#ff6450' : '#999999' }"
        @click="createEntry('个人', null)"> Create an Individual <br>Application </div>
      <div class="btn-add-entry" :style="{ backgroundColor: enableCreateIndividualApp ? '#ff6450' : '#999999' }"
        style="margin-left: 15px;" @click="createEntry('团队', null)"> Create a Team <br>Application
      </div>
      <div class="btn-add-entry" v-if="checkEnableShowFeatureAwardButton()"
        :style="{ backgroundColor: enableCreateIndividualApp ? '#ff6450' : '#999999' }" style="margin-left: 15px;"
        @click="showFeatureAwardListView = true"> Feature Award <br>Application
      </div>
      <div style="margin-left: 15px;color: #333;font-size: 14px;">
        <p>Please note:</p>
        <!-- <p v-html="str_note_1"></p> -->
        <p v-html="str_note_2"></p>
      </div>
    </div>
    <div v-if="showFeatureAwardListView == false && dataList">
      <div v-for="(item, index) in dataList" :key="index">
        <ActivityEntry :info="item" :index="index" @standards="showStandardsDialog(item)" @edit="editEntry(item)"
         @submitDate="doSubmitReviewEntryDate(item)"
          @remove="removeEntry(item)" @quitEntry="handleQuitEntry" />
      </div>
    </div>
    <FeatureAwards v-if="showFeatureAwardListView == true" style="margin-top: 20px;"
      @handleApplyFeatureAward="handleApplyFeatureAward"></FeatureAwards>

    <el-dialog :visible.sync="dialogVisible" width="70%" :before-close="handleClose">
      <div style="margin-top: -30px;width: 100%;padding: 0px 30px;">
        <p v-if="checkIsFeatureAwardEntry()"
          style="text-align: center;color: #ff6450;font-size: 28px;font-weight: bold;">New Feature Award Application</p>
        <p v-else style="text-align: center;color: #ff6450;font-size: 28px;font-weight: bold;">{{
          entryInfo.application_type ==
            '个人' ? 'New Individual Application' : 'New Team Application' }}</p>
        <el-form :model="entryInfo" :rules="rules" ref="entryForm" label-position="right" label-width="140px"
          style="margin-top: 20px;">
          <el-form-item v-if="checkIsFeatureAwardEntry()" label="Feature Award">
            <el-input v-model="entryInfo.featue_award_title" :disabled="true" style="width: 80%;"></el-input>
          </el-form-item>
          <el-form-item v-else label="Project">
            <el-input v-model="entryInfo.show_project" :disabled="true" style="width: 80%;"></el-input>
          </el-form-item>
          <el-form-item label="Application Type">
            <el-input v-model="entryInfo.show_type" :disabled="true" style="width: 80%;"></el-input>
          </el-form-item>
          <el-form-item label="Entry Title" prop="title">
            <el-input v-model="entryInfo.title" style="width: 80%;" @input="handleTitleInputChanged"
              placeholder="Maximum 50 characters"></el-input>
          </el-form-item>
          <el-form-item label="Entry Type" prop="entry_type">
            <el-radio v-model="entryInfo.entry_type" :disabled="checkIsFeatureAwardEntry()"
              label="story_line">Storyline</el-radio>
            <el-radio v-model="entryInfo.entry_type" :disabled="checkIsFeatureAwardEntry()"
              label="single_activity">Single
              Activity</el-radio>
          </el-form-item>
          <el-form-item label="Category" prop="category_id">
            <el-select v-model="entryInfo.category_id" placeholder="" :disabled="checkIsFeatureAwardEntry()">
              <el-option v-for="(type, index) in categories" :key="index" :label="type.name"
                :value="type._id.$id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Team Type" v-if="entryInfo.application_type == '团队'" prop="team_type">
            <el-select v-model="entryInfo.team_type" placeholder="Please select" :disabled="checkIsFeatureAwardEntry()">
              <el-option label="Student Association" value="Student Association"></el-option>
              <el-option label="Student Club" value="Student Club"></el-option>
              <el-option label="Project Team" value="Project Team"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Tags" prop="tags">
            <vue-tags-input style="font-size: 16px;" v-model="tag" :tags="tags" :max-tags="5"
              :placeholder="tags.length > 0 ? '' : tagPlaceHolder" @tags-changed="newTags => tags = newTags" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="flex items-center justify-center">
          <el-button type="primary" @click="saveNewEntry">Submit</el-button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="submitConfirmVisible"
      title="Confirm Submission"
      width="480px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="cancelSubmitConfirm">
      <div style="color: #333; font-size: 14px; line-height: 1.6;">
        <p style="margin-bottom: 12px;">
          You are about to submit this entry for review. <strong style="color: #ff6450;">Once submitted, you will not be able to edit it.</strong>
        </p>
        <p style="margin-bottom: 12px;">
          To confirm, please type <strong>CONFIRM</strong> (all caps) in the box below.
        </p>
        <el-input
          v-model="submitConfirmText"
          placeholder="Type CONFIRM to proceed"
          maxlength="7"
          @input="handleConfirmInput"
          style="text-transform: uppercase;"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmitConfirm">Cancel</el-button>
        <el-button
          type="primary"
          :disabled="submitConfirmText !== 'CONFIRM' || submittingEntry"
          :loading="submittingEntry"
          @click="confirmSubmitEntry">
          Submit
        </el-button>
      </span>
    </el-dialog>

    <el-empty description="No Data Yet" v-if="!dataList || dataList.length === 0"></el-empty>
  </div>
</template>

<script>
import {
  submitReviewEntryDate,
  getTypes,
  removeReviewEntry,
  checkRegistration,
  getReviewEntriesByUserIdV1,
  getReviewEntriesCountsByProject,
  getCurrentProjectManage,
  getStudentMemberShipExpiredDate,
  updateReviewEntry,
  removeEntryPeople,
  postRequest
} from "../../api/eae";
import { getUserId, FORMAT_PROJECT } from "../../utils/store";
import ActivityEntry from "../../components/ActivityEntry.vue";
import FeatureAwards from "../../components/FeatureAwards.vue";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  name: "index",
  components: {
    FeatureAwards,
    VueTagsInput,
    ActivityEntry,
  },
  data() {
    return {
      tagPlaceHolder: 'Maximum 5 tags, click "enter" for each',
      FORMAT_PROJECT,
      separators: [","],
      tag: '',
      tags: [],
      dataList: [],
      dialogVisible: false,
      alreadyEntryCounts: -1,
      currentProjectManage: {},
      entryInfo: {
        id: '',
        category_id: '',
        title: '',
        intro: '',
        user_id: getUserId(),
        open_status: 'YES',
        entry_type: '',
        show_type: '',
        application_type: '',
        team_type: '',
        tags: ''
      },
      rules: {
        title: [
          { required: true, message: 'Please input', trigger: 'blur' }
        ],
        entry_type: [
          { required: true, message: 'Please select', trigger: 'blur' }
        ],
        team_type: [
          { required: true, message: 'Please select', trigger: 'blur' }
        ],
        category_id: [
          { required: true, message: 'Please select', trigger: 'blur' }
        ],
      },
      categories: [],
      enableCreateIndividualApp: true,
      enableCreateTeamApp: true,

      str_note_1: '',
      str_note_2: '',
      membership_status: "no",

      showFeatureAwardListView: false,

      submitConfirmVisible: false,
      submitConfirmText: '',
      pendingSubmitItem: null,
      submittingEntry: false,
    };
  },
  async mounted() {
    try {
      await this.fetchData();
    } catch (error) {
      console.error('Error loading data:', error);
      // Initialize empty arrays if data loading fails
      this.dataList = [];
      this.categories = [];
      this.tags = [];
    }
  },
  methods: {

    doSubmitReviewEntryDate(item){
      this.pendingSubmitItem = item;
      this.submitConfirmText = '';
      this.submitConfirmVisible = true;
    },

    handleConfirmInput(value) {
      this.submitConfirmText = (value || '').toUpperCase();
    },

    cancelSubmitConfirm() {
      if (this.submittingEntry) {
        return;
      }
      this.submitConfirmVisible = false;
      this.submitConfirmText = '';
      this.pendingSubmitItem = null;
    },

    confirmSubmitEntry() {
      if (this.submitConfirmText !== 'CONFIRM' || !this.pendingSubmitItem) {
        return;
      }
      this.submittingEntry = true;
      submitReviewEntryDate(this.pendingSubmitItem._id.$id).then((res) => {
        this.$message.success("Submit Successfully");
        this.submitConfirmVisible = false;
        this.submitConfirmText = '';
        this.pendingSubmitItem = null;
        this.submittingEntry = false;
        this.fetchData();
      }).catch(() => {
        this.submittingEntry = false;
      });
    },

    checkEnableShowFeatureAwardButton() {
      return (getUserId() == '61cd6856a4640b946f8b456f' || getUserId() == '64b0f34ca4640b167b8b45b2' || getUserId() == '654de577a4640bc4308b45ee')
    },

    checkIsFeatureAwardEntry() {
      if (!this.entryInfo) {
        return false
      }
      let result = false
      if (this.entryInfo.feature_award_id && this.entryInfo.feature_award_id != '') {
        result = true
      }
      return result
    },

    handleApplyFeatureAward(feature_award) {
      this.createEntry(feature_award.application_type, feature_award)
    },

    formatLastCount() {
      if (this.alreadyEntryCounts == 0) {
        return 'four'
      }
      if (this.alreadyEntryCounts == 1) {
        return 'three'
      }
      if (this.alreadyEntryCounts == 2) {
        return 'two'
      }
      if (this.alreadyEntryCounts == 3) {
        return 'one'
      }
    },

    handleTitleInputChanged(value) {
      if (value) {
        this.entryInfo.title = value.charAt(0).toUpperCase() + value.slice(1);
      }
    },

    saveNewEntry() {
      let titleLength = this.entryInfo.title.length;
      if (titleLength > 50) {
        this.$message.error("Entry title characters at maximum 50");
        return;
      }
      if (this.entryInfo.tags) {
        let temp_tags = this.entryInfo.tags.split(',')
        if (temp_tags.length > 5) {
          this.$message.error('Entry tags at maximum  5 tags')
          return
        }
      }
      this.entryInfo.tags = ''
      if (this.tags.length > 0) {
        let length = this.tags.length
        for (var i = 0; i < length; i++) {
          var tag = this.tags[i].text
          this.entryInfo.tags = this.entryInfo.tags + tag
          if (i != (length - 1)) {
            this.entryInfo.tags = this.entryInfo.tags + ","
          }
        }
      }
      this.$refs['entryForm'].validate((val) => {
        if (val) {
          updateReviewEntry(this.entryInfo).then((res) => {
            let result = res.data
            if (result.code == 0) {
              this.dialogVisible = false
              this.$message.success("Submit Successful");
              this.$router.push({
                path: "entryEdit",
                query: {
                  id: result.data._id.$id,
                },
              });
            } else {
              this.$message.error(result.msg);
            }
          })
        }
      })
    },

    async createEntry(application_type, feature_award) {
      try {
        console.log('Starting createEntry');
        console.log('application_type:', application_type);
        
        this.showFeatureAwardListView = false;
        
        // Add defensive checks
        if (!this.enableCreateIndividualApp && application_type === '个人') {
          console.log('Individual applications disabled');
          return;
        }
        if (!this.enableCreateTeamApp && application_type === '团队') {
          console.log('Team applications disabled');
          return;
        }

        console.log('Time check passed');
        //查看会员
        if (this.membership_status != 'yes') {
          this.$message.error('Please pay registration')
          if (getUserId() == '61cd6856a4640b946f8b456f' || getUserId() == '64b0f34ca4640b167b8b45b2' || getUserId() == '654de577a4640bc4308b45ee') {
            this.$router.push("/home/universal-pass");
            return
          }
          this.$router.push({
            path: "/home/registration",
          });
          return
        }

        console.log('时间没过2')
        //查看已经创建个个数
        if (this.alreadyEntryCounts == -1) {//这种情况不应该出现，但是还要判断一下
          this.$message.error("No project found");
          return
        }

        if (this.alreadyEntryCounts >= 4) {
          this.$message.error("Maximum four applications per subscription cycle.");
          return;
        }
        console.log('时间没过3')
        let user_id = getUserId();
        let checkResult = await checkRegistration(user_id) //主要判断是不是会员，以及会员是否过期了
        if (checkResult.data.code != 0) {
          this.$message.error(res.data.msg);
          if (getUserId() == '61cd6856a4640b946f8b456f' || getUserId() == '64b0f34ca4640b167b8b45b2' || getUserId() == '654de577a4640bc4308b45ee') {
            this.$router.push("/home/universal-pass");
            return
          }
          this.$router.push({
            path: "/home/registration",
          });
        }
        console.log('时间没过4'+this.currentProjectManage.project_code)
        this.entryInfo = {
          id: '',
          show_project: this.currentProjectManage.project_code,
          category_id: feature_award ? feature_award.category_id : '',
          title: '',
          intro: '',
          user_id: user_id,
          open_status: 'YES',
          entry_type: feature_award ? feature_award.entry_type : '',
          application_type: application_type,
          team_type: feature_award ? feature_award.team_type : '',
          tags: '',
          feature_award_id: feature_award ? feature_award._id.$id : '',
          featue_award_title: feature_award ? feature_award.award_title : ''
        }
        console.log('时间没过5' + this.entryInfo.show_project)
        this.tags = []
        this.tag = ''
        console.log('时间没过6')
        if (this.entryInfo.application_type == '个人') {
          this.entryInfo.show_type = 'Individual Application'
        } else {
          this.entryInfo.show_type = 'Team Application'
        }
        console.log('时间没过7')
        this.dialogVisible = true
        console.log('时间没过8')
      } catch (error) {
        console.error('Error in createEntry:', error);
        this.$message.error('An error occurred while creating the entry');
      }
    },

    convertTimeToEng(time) {
      var date = new Date(time * 1000);
      let year = date.getFullYear();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      return this.formatMonthToEng(month) + " " + day + ", " + year;
    },

    formatMonthToEng(month) {
      switch (month) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }
    },

    removeEntry(item) {
      removeReviewEntry(item._id.$id).then((res) => {
        this.$message.success("Deleted Successfully");
        this.fetchData();
      });
    },

    async fetchData() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      
      try {
        let user_id = getUserId();

        let reiviewEntryListResult = await getReviewEntriesByUserIdV1(user_id)
        // Create a plain array first, then assign it
        const plainDataList = reiviewEntryListResult.data.data.map(item => {
          try {
            // Parse the JSON strings and create plain objects
            let parsedProjectManage = Object.create(null);
            let parsedType = Object.create(null);
            
            if (typeof item.projectManage === 'string') {
              Object.assign(parsedProjectManage, JSON.parse(item.projectManage));
            } else if (item.projectManage) {
              // Copy all properties first
              Object.assign(parsedProjectManage, item.projectManage);
              
              // Handle entry_date separately if it's a string
              if (typeof item.projectManage.entry_dates === 'string') {
                let parsedEntryDates = JSON.parse(item.projectManage.entry_dates);
                parsedProjectManage.entry_dates = parsedEntryDates;
              }
            }
            console.log('parsedProjectManage', parsedProjectManage)
            if (typeof item.type === 'string') {
              Object.assign(parsedType, JSON.parse(item.type));
            } else if (item.type) {
              Object.assign(parsedType, item.type);
            }
            
            // Create a plain object without Vue reactivity
            const plainItem = Object.create(null);
            Object.assign(plainItem, item, {
              projectManage: parsedProjectManage,
              type: parsedType,
              category: item.category ? Object.assign(Object.create(null), item.category) : Object.create(null)
            });
            
            return plainItem;
          } catch (parseError) {
            console.error('Error parsing item data:', parseError, item);
            const plainItem = Object.create(null);
            Object.assign(plainItem, item, {
              projectManage: Object.create(null),
              type: Object.create(null),
              category: Object.create(null)
            });
            return plainItem;
          }
        }).filter(item => {
          // Filter out items with invalid data
          return item && item.projectManage && typeof item.projectManage === 'object';
        });

        // Assign the plain array to avoid Vue reactivity
        this.$set(this, 'dataList', plainDataList);

        console.log('dataList', this.dataList)

        let reiviewEntryCountResult = await getReviewEntriesCountsByProject(user_id)
        console.log('reiviewEntryCountResult', reiviewEntryCountResult)
        if (reiviewEntryCountResult.data.code == 0) {
          this.alreadyEntryCounts = reiviewEntryCountResult.data.data
        } else {
          this.alreadyEntryCounts = -1
        }
        console.log('alreadyEntryCounts', this.alreadyEntryCounts)
        let categoryListResult = await postRequest({
          function: 'getTypesSimple'
        })
        console.log('categoryListResult', categoryListResult)
        this.categories = categoryListResult.data.data

        let currentProjectManageResult = await getCurrentProjectManage()
        const projectManageData = currentProjectManageResult.data || {}

        // Backend now returns { current: {...}, next: {...} }
        const currentProject = projectManageData.current || null
        const nextProject = projectManageData.next || null

        // Keep current year's project manage for other logic (e.g. project_code)
        this.currentProjectManage = currentProject || {}

        // Helper to safely normalize entry dates from a project manage object
        const normalizeEntryDates = (pm) => {
          if (!pm) return []
          let dates = pm.entry_dates || pm.entry_date || []
          if (!Array.isArray(dates)) {
            console.warn('entry_dates is not an array on project manage:', pm)
            return []
          }
          return dates
        }

        // Merge current year and next year's entry dates (total 8 quarters)
        let entry_date = [
          ...normalizeEntryDates(currentProject),
          ...normalizeEntryDates(nextProject)
        ]

        if (!entry_date || entry_date.length === 0) {
          console.warn('No entry dates found in current or next year project manage', projectManageData)
        }

        if (entry_date && entry_date.length > 0) {
          entry_date.sort(function (a, b) {
            return a.ddl_date - b.ddl_date
          })
        }

        let currentTime = parseInt(new Date().getTime() / 1000)
        console.log('Date finding logic:', {
          entry_date_length: entry_date ? entry_date.length : 0,
          currentTime: currentTime,
          currentTimeMs: currentTime * 1000,
          currentTimeFormatted: new Date(currentTime * 1000).toISOString()
        })
        let one_day = 24 * 60 * 60 * 1000 - 1

        let indie_submission_date = -1
        let team_submission_date = -1
        for (let i = 0; i < entry_date.length; i++) {
          let item = entry_date[i]
          let ddl_date = 0
          if (getUserId() == "66bc7379a4640b966a8b4569") {//特殊处理一下
            ddl_date = parseInt((item.ddl_date + 2 * one_day) / 1000)
          } else {
            ddl_date = parseInt((item.ddl_date + one_day) / 1000)
          }
          if (item.app_type == 'indie' && indie_submission_date == -1) {
            if(currentTime < ddl_date){
              indie_submission_date = ddl_date
            }
          }

          if (item.app_type == 'team' && team_submission_date == -1) {
            if(currentTime < ddl_date){
              team_submission_date = ddl_date
            }
          }
        }

        let submission_date = new Date(indie_submission_date * 1000)
        let submission_year_end_time = parseInt(new Date(submission_date.getFullYear(), 11, 31, 23, 59, 59).getTime() / 1000)

        if (currentTime > indie_submission_date && currentTime <= submission_year_end_time) {
          this.enableCreateIndividualApp = false
        }
        if (currentTime > team_submission_date && currentTime <= submission_year_end_time) {
          this.enableCreateTeamApp = false
        }

        //这边逻辑先暂时写死，后面需要轮训获取
        
        // Use the sorted entry_date array to find next upcoming dates
        // entry_date is already sorted by ddl_date above
        // First try to find future dates
        let indieDate = entry_date && entry_date.length > 0 
          ? entry_date.find(d => d.app_type === 'indie' && d.ddl_date > currentTime*1000)
          : null;
        let teamDate = entry_date && entry_date.length > 0
          ? entry_date.find(d => d.app_type === 'team' && d.ddl_date > currentTime*1000)
          : null;
        
        // If no future dates found, fall back to the most recent dates (last ones in sorted array)
        if (!indieDate && entry_date && entry_date.length > 0) {
          const indieDates = entry_date.filter(d => d.app_type === 'indie');
          if (indieDates.length > 0) {
            indieDate = indieDates[indieDates.length - 1]; // Get the last (most recent) indie date
          }
        }
        
        if (!teamDate && entry_date && entry_date.length > 0) {
          const teamDates = entry_date.filter(d => d.app_type === 'team');
          if (teamDates.length > 0) {
            teamDate = teamDates[teamDates.length - 1]; // Get the last (most recent) team date
          }
        }
        
        // Add safety checks for the dates
        if (!indieDate || !teamDate) {
          console.warn('Could not find valid dates for indie or team applications', {
            indieDate,
            teamDate,
            entry_date_length: entry_date ? entry_date.length : 0,
            entry_date: entry_date,
            currentTime: currentTime * 1000,
            currentTimeFormatted: new Date(currentTime * 1000).toISOString(),
            allDates: entry_date ? entry_date.map(d => ({
              name: d.name,
              app_type: d.app_type,
              ddl_date: d.ddl_date,
              ddl_date_formatted: new Date(d.ddl_date).toISOString(),
              isFuture: d.ddl_date > currentTime * 1000
            })) : []
          });
          this.str_note_2 = 'Deadline information is not available at this time.';
        } else {
          let indieDateStr = new Date(indieDate.ddl_date).toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric', 
            year: 'numeric'
          });
          
          let teamDateStr = new Date(teamDate.ddl_date).toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          });

          this.str_note_2 = `The deadlines for the upcoming review cycles are <span style="color: #ff6450;">${indieDateStr},&nbsp;for 
                individual applications</span>
            and <span style="color: #ff6450;"> ${teamDateStr} ,&nbsp;for team applications</span>.`
        }

        let studentMembershipResult = await getStudentMemberShipExpiredDate({ student_id: user_id })
        let studentMembershipExpiredTime = studentMembershipResult.data.data

        if (studentMembershipExpiredTime == -1) {
          this.alreadyEntryCounts = 4
          this.membership_status = 'no'
          // this.str_note_1 = 'You need to purchase EAE Awards subscription for applications.'
        } else {
          let current_time = parseInt(new Date().getTime() / 1000)
          let membership_date = this.convertTimeToEng(studentMembershipExpiredTime)
          if (studentMembershipExpiredTime <= current_time) {
            this.membership_status = 'expired'
            // this.str_note_1 = `Your EAE Awards subscription has expired on ${membership_date}.`
          } else {
            this.membership_status = 'yes'
            if (this.alreadyEntryCounts >= 4) {
              // this.str_note_1 = `You have reached the maximum limit of 4 applications that can be created until <span style="color:#ff6450 ;">${membership_date}</span>.`
            } else {
              // this.str_note_1 = `1. You can create ${this.formatLastCount()} more ${this.alreadyEntryCounts >= 3 ? 'application' : 'applications'} by <span style="color:#ff6450 ;">${membership_date}</span>.</p>`
            }
          }
        }
      } catch (error) {
        console.error('Error in fetchData:', error);
        this.$message.error('Failed to load data. Please try again later.');
        // Set default values if there's an error
        this.dataList = [];
        this.categories = [];
        this.alreadyEntryCounts = -1;
      } finally {
        loading.close();
      }
    },
    editEntry(row) {
      //判断 有没有 报名缴费
      let user_id = getUserId();
      checkRegistration(user_id).then((res) => {
        if (res.data.code == 0) {
          this.$router.push({
            path: "entryEdit",
            query: {
              id: row._id.$id,
            },
          });
        } else {
          this.$message.error(res.data.msg);
          if (getUserId() == '61cd6856a4640b946f8b456f' || getUserId() == '64b0f34ca4640b167b8b45b2' || getUserId() == '654de577a4640bc4308b45ee') {
            this.$router.push("/home/universal-pass");
            return
          }
          this.$router.push({
            path: "/home/registration",
          });
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.showFeatureAwardListView = false
    },

    showStandardsDialog(row) {
      if (!row.activity_option_id) {
        this.$message.warning("No data");
        return;
      }
      this.$router.push({
        path: "standards",
        query: {
          id: row.activity_option_id,
          entryId: row._id.$id,
        },
      });
    },

    handleQuitEntry(params) {
      removeEntryPeople(params.entry_id, params.entry_people_id).then((res) => {
        this.$message.success('Quit Team Entry Successful')
        this.fetchData()
      })
    }
  },
};
</script>

<style>
.ti-tag {
  background-color: #ff6450 !important;
  /* 您想要的颜色 */
}

.ti-input {
  border-radius: 5px;
}
</style>

<style lang="scss" scoped>
.btn-add-entry {
  text-align: center;
  width: 200px;
  height: 80px;
  background: #ff6450;
  border-radius: 5px;
  color: white;
  font-size: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
}

.custom-btn {
  background: #ff6450;
  border-radius: 5px;
  padding: 6px 10px;
  color: white;
  font-size: 15px;
  line-height: 24px;
  cursor: pointer;
}

.entry-type {
  height: 112px;
  border: 2px solid #d9d9d9;
  border-radius: 5px;
  align-items: center;

  &.selected {
    border: 2px solid #ff6450;
    background: #fff8f7;
  }

  .cover {
    width: 108px;
    height: 108px;
    // border-radius: 5px;
  }

  .desc {
    height: 52px;
    overflow: hidden;
    font-weight: bold;
    color: #888888;
    word-break: keep-all;
  }

  .icon {
    width: 24px;
    height: 24px;
    margin-right: 18px;
  }
}

.row {
  display: flex;
  justify-content: space-between;

  .item {
    width: 420px;
    &:not(:first-child) {
      margin-left: 20px;
    }

    .label {
      font-size: 16px;
      font-family: GravityNormal;
      font-weight: normal;
      color: #666666;
    }

    .input {
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 18px;
      font-family: GravityNormal;
      font-weight: normal;
      color: #333333;

      img {
        margin-right: 24px;
        cursor: pointer;
      }
    }
  }
}
</style>
